export default __webpack_public_path__ + "static/quedemy-text-logo-rect-violet-99e12752599a8e42a3bb9215a298888e.png";